import Basket from "assets/menu-icons/Basket";
import projectConfig from "@/projectConfig";

const basket = {
  id: 'basket',
  type: 'group',
  restricted: true,
  visible: projectConfig.payment,
  children: [{
    id: 'basket',
    title: 'Корзина', 
    type: 'item',
    url: '/basket',
    icon: Basket,
    breadcrumbs: false,
    restricted: true,
    visible: projectConfig.payment,
  }]
}

export default basket;
